import OfferPage from "./OfferPage.vue";

const app = new Vue({
    el: '#offer-detail',
    components: { OfferPage },
    data: {
        dto: offerDto
    },
});
